import React from 'react';

const contextValue = {
   loading: false,
   setLoading: (state: boolean) => {},
};

export const dialogContextContext = React.createContext(contextValue);

type DialogContextProviderProps = {
   value: typeof contextValue;
   children: React.ReactNode;
};

export const useDialogContext = () => {
   const value = React.useContext(dialogContextContext);
   return value as DialogContextProviderProps['value'];
};

export const DialogContextProvider = ({value, children}: DialogContextProviderProps) => {
   const {Provider} = dialogContextContext;
   return <Provider value={value}>{children}</Provider>;
};
